<ngx-spinner
  class="fd-spinner no-print"
  bdColor="rgba(51,51,51,0.8)"
  size="default"
  color="#fff"
  type="ball-spin">
</ngx-spinner>

<router-outlet></router-outlet>
